package top.wcpe.allincore.dsl.compiler.semantic.`native`.methods

import top.wcpe.allincore.dsl.compiler.ast.ExprAst
import top.wcpe.allincore.dsl.compiler.diag.DiagnosticCollector
import top.wcpe.allincore.dsl.compiler.semantic.`native`.Arity
import top.wcpe.allincore.dsl.compiler.semantic.`native`.HostClassNames
import top.wcpe.allincore.dsl.compiler.semantic.`native`.MethodDescriptor
import top.wcpe.allincore.dsl.compiler.semantic.`native`.ResolveCtx

/**
 * 内置 object `net` 的 `subscribe` 方法描述符。
 *
 * Stage 5：实现真实 lower 逻辑，把 MemberCall 转换为 NetSubscribeCall。
 * arity 按位置参数总数粗校验：ns + topic + handler = 3。
 */
object NetSubscribeMethod : MethodDescriptor {

    override val name: String = HostClassNames.NetMethods.SUBSCRIBE

    override val arity: Arity = Arity.Fixed(3)

    /**
     * 把 MemberCall(target=IdentRef("net"), method="subscribe", args=[ns, topic, handler])
     * lower 为 ExprAst.NetSubscribeCall。
     *
     * 返回 null 表示保留原 MemberCall（参数不符合预期时的防御行为）。
     */
    override fun resolve(call: ExprAst.MemberCall, diag: DiagnosticCollector, ctx: ResolveCtx): ExprAst? {
        // 防御：target 必须是 IdentRef("net")
        val target = call.target
        if (target !is ExprAst.IdentRef || target.name != HostClassNames.NET) return null

        // 位置参数必须恰好 3 个：ns / topic / handler
        if (call.args.size != 3) return null

        val nsArg = call.args[0]
        val topicArg = call.args[1]
        val handlerArg = call.args[2]

        // args[0] 必须是 StringLit
        if (nsArg !is ExprAst.Literal.StringLit) return null
        // args[1] 必须是 StringLit
        if (topicArg !is ExprAst.Literal.StringLit) return null
        // args[2] 必须是 LambdaExpr 或 FunRefExpr
        if (handlerArg !is ExprAst.LambdaExpr && handlerArg !is ExprAst.FunRefExpr) return null

        return ExprAst.NetSubscribeCall(
            namespace = nsArg.value,
            topic = topicArg.value,
            handler = handlerArg,
            position = call.position,
        )
    }
}
